// lib
import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Calendar as LibCalendar } from "react-big-calendar";
import moment from "moment";
// src
import { useNoScroll } from "utils/hooks";
import { darken } from "utils/colors";
import { currentLocalizer, formats, formatEndAccessor, messages } from "i18n/localizer";
import Toolbar from "containers/plannings/table/partials/Toolbar";
import WeekHeader from "./partials/WeekHeader";
import FiveDays from "./views/FiveDays";
import ThreeDays from "./views/ThreeDays";

const VIEWS = {
  day: true,
  threeDays: ThreeDays,
  fiveDays: FiveDays,
  week: true,
  month: true,
  timeline: () => {}, // prevents rendering
};

const Calendar = ({
  // from parent
  handleOpenModal,
  maxHeight,
  // data props
  events,
  focus,
  isSmall,
  language,
  updatedFromPicker,
  view,
  // action props
  updateRangeAndFetch,
  updateView,
}) => {
  // Calendar's grid is scrolling, but not the whole component (with toolbar) / nor the web page
  useNoScroll();

  // Hack to refresh calendar if focus changes from outside the component (DatePicker)
  const ref = useRef(null);
  useEffect(() => {
    if (updatedFromPicker && ref.current) ref.current.props.onNavigate(focus);
  }, [updatedFromPicker, focus]);

  const styleEvent = ({ preset, private: p }) => {
    const { color } = preset;
    return {
      style: {
        backgroundColor: color,
        border: `1px solid ${darken(color)}`,
        opacity: p ? 0.8 : 1,
      },
    };
  };
  // ---- Dispatch view range updates  ----
  const handleRange = (range) => {
    let newDateStart;
    let newDateEnd;
    if (Array.isArray(range)) {
      [newDateStart] = range;
      newDateEnd = range[range.length - 1];
    } else {
      newDateStart = range.start;
      newDateEnd = range.end;
    }
    updateRangeAndFetch(moment(newDateStart).valueOf(), moment(newDateEnd).valueOf());
  };

  return (
    <div>
      <LibCalendar
        ref={ref}
        components={{
          toolbar: Toolbar,
          week: {
            header: WeekHeader,
          },
          threeDays: {
            header: WeekHeader,
          },
          fiveDays: {
            header: WeekHeader,
          },
          timeline: {
            header: WeekHeader,
          },
        }}
        defaultDate={focus}
        eventPropGetter={styleEvent}
        events={events}
        formats={formats(language, isSmall)}
        localizer={currentLocalizer(language)}
        messages={messages(language, isSmall)}
        onRangeChange={handleRange}
        onSelectEvent={handleOpenModal}
        onView={updateView}
        popup
        endAccessor={formatEndAccessor}
        scrollToTime={new Date(1970, 0, 1, 8, 0, 0)}
        selectable
        style={{ height: maxHeight }}
        titleAccessor="name"
        tooltipAccessor="name"
        view={view}
        views={VIEWS}
      />
    </div>
  );
};

Calendar.propTypes = {
  // from parent
  handleOpenModal: PropTypes.func.isRequired,
  maxHeight: PropTypes.number.isRequired,
  // data props
  events: PropTypes.array.isRequired,
  focus: PropTypes.object.isRequired,
  isSmall: PropTypes.bool.isRequired,
  language: PropTypes.string.isRequired,
  view: PropTypes.string.isRequired,
  updatedFromPicker: PropTypes.bool.isRequired,
  // actions props
  updateRangeAndFetch: PropTypes.func.isRequired,
  updateView: PropTypes.func.isRequired,
};

export default Calendar;
